<div class="message-indicator" *ngIf="indicatorVisible" [@focusedTrigger]="indicatorVisible" tabindex="0">
    {{ unreadQueue?.length }}
</div>
